/**
 * Parse a fetch Response as JSON.
 *
 * Cloud Run / load-balancer 404s return HTML (`<!DOCTYPE html>` / `<html>`).
 * Hermes then throws: JSON Parse error: Unexpected character: <
 */
export async function readResponseJson<T = any>(response: Response): Promise<T> {
  const text = await response.text();
  const trimmed = text.trim();

  if (!trimmed) {
    throw new Error(`Empty response from server (${response.status})`);
  }

  if (trimmed.startsWith('<')) {
    throw new Error(
      `API returned HTML instead of JSON (${response.status}). The backend URL may be wrong or the service is down.`
    );
  }

  try {
    return JSON.parse(trimmed) as T;
  } catch {
    throw new Error(`Invalid JSON from server (${response.status})`);
  }
}
